import {
  Pie,
  Tooltip,
  ResponsiveContainer,
  PieChart as REPieChart,
} from "recharts";
import PropTypes from "prop-types";

import { Legend } from "./Legend";

export const PieChart = ({
  width = 210,
  height = 210,
  data = [],
  showLegend = true,
  innerRadius = 80,
  legendContent,
  labelContent,
  tooltipContent,
  legendProps,
  pieProps,
  pieChartProps,
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <REPieChart
        className="pie-chart"
        width={width}
        height={height}
        {...pieChartProps}
      >
        {/* legend */}
        {showLegend && (
          <Legend
            align="right"
            layout="vertical"
            verticalAlign="middle"
            content={legendContent}
            {...legendProps}
          />
        )}

        {/* tooltip */}
        {tooltipContent && <Tooltip content={tooltipContent} />}

        {/* chart */}
        <Pie
          cx="50%"
          cy="50%"
          dataKey="value"
          data={data}
          labelLine={false}
          label={labelContent}
          innerRadius={innerRadius}
          stroke={0}
          {...pieProps}
        />
      </REPieChart>
    </ResponsiveContainer>
  );
};

PieChart.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.array,
  showLegend: PropTypes.bool,
  innerRadius: PropTypes.number,
  legendContent: PropTypes.elementType,
  labelContent: PropTypes.elementType,
  tooltipContent: PropTypes.elementType,
  legendProps: PropTypes.object,
  pieProps: PropTypes.object,
  pieChartProps: PropTypes.object,
};
